import appIllustration from '@/views/illustration.vue'
import { createRouter, createWebHistory } from 'vue-router'
import appAbout from '../views/about.vue'
import appContact from '../views/contact.vue'
import appHome from '../views/home.vue'
import appIdTags from '../views/idtags'
import appPolicy from '../views/policy.vue'
import appProduct from '../views/product.vue'
import appSupport from '../views/support.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: appHome
  },
  {
    path: '/about',
    name: 'about',
    component: appAbout
  },
  {
    path: '/product',
    name: 'product',
    component: appProduct
  },
  {
    path: '/support',
    name: 'support',
    component: appSupport
  },
  {
    path: '/contact',
    name: 'contact',
    component: appContact
  },
  {
    path: '/idtags',
    name: 'idtags',
    component: appIdTags
  },
  {
    path: '/policy',
    name: 'policy',
    component: appPolicy
  },
   {
    path: '/illustration',
    name: 'illustration',
    component: appIllustration
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
